const serverApp = 'assetms';

export const environment = {
  serverApp: serverApp,
  production: true,
  apiBaseUrl: `https://app.assetotal.com/${serverApp}`,
  wsUrl: `https://app.assetotal.com/${serverApp}/ws`,
  orgUrl: 'https://www.assetotal.com/',
  codatronUrl: 'https://www.codatron.in/',
  erpLogoUrl: 'assets/images/asset_total-logo.png',
  erpFaviconUrl: 'assets/images/asset_total-logo.png',
  erpLoadingUrl: 'assets/images/asset_total-logo.png',
  erpUserDefaultUrl: 'assets/images/asset_total-logo.png',
  codatronLogoUrl: 'assets/images/Codatron.png',
  noImageUrl: 'assets/images/No_Image_Available.png',
  tempImageUrl: 'https://www.assetotal.com/',
  pageAccessErrorMsg: 'You are not authorized to view this page.',
  actionAccessErrorMsg: 'You are not authorized to perform this action.',
  showCode: false,
  showCostDistribution: false,
  useWebSocket: false,
  turnstileSitekey: '0x4AAAAAABxRU9wUtnGukqiQ',
  kiIndustryType: {
    NDT: 'NDT',
    HOME: 'HOME',
  },
  defaultLoginMode: 'email' as 'email' | 'mobile',
  defaultPasswordMode: true,
  defaultCountryCode: 'IN',
};
